<template>
  <div class="h-100 my-5">
    <b-button
      type="submit"
      class="myButton"
      @click="$router.go(-1)">
      {{ $t('common.Back') }}
    </b-button>
    <div class="dp02 p-3 mt-3">
      <div class="text-center col-lg-12">
        <h2>{{ $t('ViewRole.Viewing') }} {{ roleName }}</h2>
      </div>
      <div class="row">
        <div class="col-8 offset-2 mt-1 text-center">
          <div class="row">
            <div class="col-12 text-center">
              <h3>{{ $t('ViewRole.AssignedPermissions') }}</h3>
              <div class="dp04">
                <draggable group="permissions"
                           v-model="rolePermissions"
                           class="draggableWindow"
                           :disabled="true">
                  <transition-group class="permission-group">
                    <div v-for="element in rolePermissions"
                         :key="element.value"
                         class="dp04 list-group-item draggableItem">
                      <font-awesome-icon icon="grip-horizontal"
                                         class="float-left" />
                      {{ element.displayName }}
                    </div>
                  </transition-group>
                </draggable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import draggable from 'vuedraggable';

export default {
  name: 'ViewRoleDetail',
  components: {
    draggable
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    ...mapState('viewRole', ['roleName', 'rolePermissions'])
  },
  created() {
    this.resetContext();
    this.setRoleId(Number(this.id));
    this.fetchRole();
  },
  methods: {
    ...mapMutations({
      setRoleId: 'viewRole/setRoleId'
    }),
    ...mapActions({ resetContext: 'viewRole/resetContext',
      fetchRole: 'viewRole/fetchRole' })
  }
};
</script>

<style lang="scss" scoped>
.draggableWindow {
  min-height:300px;
  max-height:300px;
  overflow-y: scroll;
}

.draggableItem:hover {
  background-color: rgba(255, 255, 255, 0.11);
}

.permission-group-leave-active{
        display:none!important;
}

.windowRemoving {
  background-color: rgba(216, 86, 86, 0.4);
  transition: 0.6s all;
}

.windowAdding {
  background-color: rgba(37, 128, 37, 0.705);
  transition: 0.6s all;
}
</style>
